var render = function render(){var _vm=this,_c=_vm._self._c;return _c('key-value',{attrs:{"title":_vm.title}},[(_vm.value)?_c('span',[_c('span',[_vm._v(" 1 "+_vm._s(_vm.getCurrencyName(_vm.from)))]),_vm._v(" =~ "),_c('strong',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.value))+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.getCurrencyName(_vm.to)))])]):_c('span',[_vm._v(" -- ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }